import { render, staticRenderFns } from "./RoomsListWidget.vue?vue&type=template&id=213ff5ca"
import script from "./RoomsListWidget.vue?vue&type=script&lang=js"
export * from "./RoomsListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports